export const UPDATE_HOME = "UPDATE_HOME";
export const UPDATE_ABOUT = "UPDATE_ABOUT";
export const UPDATE_NEWS = "UPDATE_NEWS";
export const UPDATE_CONTACTUS = "UPDATE_CONTACTUS";
export const UPDATE_PRODUCT = "UPDATE_PRODUCT";
export const UPDATE_FOOTER = "UPDATE_FOOTER";
export const UPDATE_SERVICE = "UPDATE_SERVICE";
export const UPDATE_MENU = "UPDATE_MENU";
export const UPDATE_SUBMENU_PAGE = "UPDATE_SUBMENU_PAGE";
export const UPDATE_NEWS_DEFAULT = "UPDATE_NEWS_DEFAULT";
export const UPDATE_NEWSLETTER = "UPDATE_NEWSLETTER";
export const UPDATE_SLIDER = "UPDATE_SLIDER";
export const UPDATE_RANDD = "UPDATE_RANDD";
export const UPDATE_INDUSTRIES = "UPDATE_INDUSTRIES";
export const UPDATE_COMPANY = "UPDATE_COMPANY";
export const UPDATE_SERVICES = "UPDATE_SERVICES";
export const AUTH_LOGIN_START = "AUTH_LOGIN_START";
export const AUTH_LOGIN_SUCCESS = "AUTH_LOGIN_SUCCESS";
export const AUTH_LOGIN_FAILURE = "AUTH_LOGIN_FAILURE";
export const AUTH_LOGOUT = "AUTH_LOGOUT";
export const AUTH_RESTORE_SESSION = "AUTH_RESTORE_SESSION";
export const AUTH_SET_PERMISSIONS = "AUTH_SET_PERMISSIONS";
